<template>
    <div
        class="c-message_kit__reaction_bar c-reaction_bar c-reaction_bar--light c-reaction_bar--collapsed"
        role="group"
        data-qa="reaction_bar"
        aria-label="Reactions"
        data-stringify-ignore="true"
        v-if="reactions.length"
    >
        <template>
            <div v-for="(reaction, key) in reactions">
              <button
                  aria-label="1 reaction, react with raised hands emoji"
                  aria-pressed="true"
                  data-qa="reactji"
                  delay="300"
                  data-sk="tooltip_parent"
                  type="button"
                  :class="['c-button-unstyled', 'c-reaction', 'c-reaction--light', {'c-reaction--reacted': reaction.reacted}]"
                  :key="key"
                  @click="toggle_reaction(reaction)"
              >
                <img
                    :src="img"
                    class="c-emoji c-emoji__small"
                    data-qa="emoji"
                    data-stringify-type="emoji"
                    v-for="(img, key) in reaction.imgs"
                    :data-stringify-emoji="`:${reaction.emoji.name}:`"
                    :key="`img-${key}`"
                >
                <span class="c-reaction__count">{{reaction.count}}</span>
              </button>
            </div>
        </template>
        <button
            class="c-button-unstyled c-reaction_add c-reaction_add--light"
            aria-label="Add reaction..."
            data-qa="add_reaction_button"
            delay="300"
            aria-haspopup="true"
            data-sk="tooltip_parent"
            type="button"
            @click="$emit('add_reaction', { e: $event, msg: message, type: 'reaction' })"
        >
            <div class="c-reaction_add__container"><i
                    class="c-icon c-reaction_add__icon c-reaction_add__icon--bg c-icon--small-reaction-bg"
                    type="small-reaction-bg"
                    aria-hidden="true"
                ></i><i
                    class="c-icon c-reaction_add__icon c-reaction_add__icon--fg c-icon--small-reaction"
                    type="small-reaction"
                    aria-hidden="true"
                ></i></div>
        </button>
    </div>
</template>

<script>
import { get_user_info, is_me, reactions } from '../../slack_api'
import emojis from '../emoji-picker/emojis.json'
export default {
    computed: {
        reactions() {
            return (this.message.reactions && this.message.reactions.reduce((items, r) => {
                const parts = r.name.split('::')
                    , id = parts[0]
                let item = items.find(i => i.id === id)
                const is_new_item = !item
                item = item || r
                item.id = id
                item.skin_tone = parts.length === 2 ? parts[1] : 'default'
                item.imgs = item.imgs || []
                item.emoji = this.emojisObject[item.id] || emojis.reduce((_, group) => (_ || group.emojis.find(e => e.id === item.id)), null)
                this.emojisObject[item.id] = item.emoji
                !item.imgs.includes(item.emoji[item.skin_tone]) && item.imgs.push(item.emoji[item.skin_tone])
                item.reacted = item.users.some(u => is_me(u))
                if (is_new_item) {
                    items.push(item)
                }
                return items
            }, []) || []).filter(r => r.emoji)
        }
    },
    data() {
        return {
            emojisObject: {},
            usersObject: {},
        }
    },
    methods: {
        toggle_reaction(reaction) {
            this.$emit('react', reaction)
        },

    },
    mounted() {
        const promises = []
        this.reactions.forEach((reaction) => reaction.users.forEach(user_id => !this.usersObject[user_id] && promises.push(get_user_info(user_id).then(user => !!user && (this.usersObject[user_id] = user)))))
        Promise.allSettled(promises).then(() => this.$forceUpdate())
    },
    props: ['channel', 'message'],
}
</script>

<style>
.c-message_kit__reaction_bar {
  margin-bottom: 4px; }
.c-message_kit__reaction_bar .c-reaction, .c-message_kit__reaction_bar .c-reaction_add {
  margin-bottom: 4px;
  margin-right: 4px; }

.c-reaction {
  font-size: 11px;
  line-height: 16px;
  padding: 4px 6px;
  display: inline-flex;
  align-items: center;
  vertical-align: top;
  background: rgba(var(--sk_foreground_min, 29, 28, 29), 0.04);
  border: none;
  border-radius: 12px;
  margin-right: 5px;
  margin-bottom: 5px; }
.c-reaction .c-emoji:not(:last-child) {
  margin-right: 2px; }

.c-reaction-count {
  color: rgba(var(--sk_primary_foreground, 29, 28, 29), 1);
  padding: 0 1px 0 3px; }

.c-reaction--reacted .c-reaction__count {
  color: rgba(var(--sk_highlight, 18, 100, 163), 1);
  font-weight: 700; }

.c-reaction--reacted, .c-reaction--reacted:hover {
  --saf-0: rgba(var(--sk_highlight_accent, 29, 155, 209), 1);
  box-shadow: inset 0 0 0 1px var(--saf-0);
  background: rgba(29, 155, 209, 0.1); }

.c-reaction_add:hover, .c-reaction_expand:hover {
  --saf-0: rgba(var(--sk_foreground_high, 29, 28, 29), 0.5);
  box-shadow: inset 0 0 0 1px var(--saf-0);
  background: rgba(var(--sk_primary_background, 255, 255, 255), 1); }

.c-reaction_add, .c-reaction_expand {
  font-size: 11px;
  line-height: 16px;
  padding: 4px 6px;
  vertical-align: top;
  background: rgba(var(--sk_foreground_min, 29, 28, 29), 0.04);
  border: none;
  border-radius: 12px;
  margin-right: 5px;
  margin-bottom: 5px;
  padding: 2px 6px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 34px; }

.c-reaction_add__container {
  width: 20px;
  height: 20px;
  position: relative;
  transform: translateX(-1px); }

.c-reaction_add__icon--bg {
  color: transparent; }

.c-reaction_add__icon {
  position: absolute;
  display: block; }

.c-reaction_add__icon--fg {
  z-index: 1;
  color: rgba(var(--sk_foreground_max, 29, 28, 29), 0.7); }

.c-reaction_add:focus .c-reaction_add__icon--bg, .c-reaction_add:hover .c-reaction_add__icon--bg {
  color: rgba(var(--sk_secondary_highlight, 242, 199, 68), 1); }

</style>